module.exports = __webpack_public_path__ + "media/icons/pochodzenie-polska-blue@2x-37904fd4.png";